// External libraries
import React, { Component } from 'react';
// @ts-expect-error
import { LoadingSpinner } from '@checkout/react-components';

// Internal modules
import { logger } from '@/lib/logger';
import { fallback } from '@/lib/utils/redirects';
import { CI } from '@/lib/customerInteractions';

type ErrorState = {
  hasError: boolean;
};

type Error = {
  name: string;
  message: any;
  stack?: any;
};

type ErrorInfo = {
  componentStack: string;
};
class ErrorBoundary extends Component {
  state: ErrorState = {
    hasError: false,
  };

  static getDerivedStateFromError(): ErrorState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    const { message = error, stack } = error;
    const { componentStack = errorInfo } = errorInfo;
    const logMessage = message.replace(/\s/g, '_');

    logger.error(`error_boundary_${logMessage}`, {
      componentStack,
      error: message,
      stack,
    });

    CI.endAll(CI.Status.FCI);

    fallback({ reason: 'weasley_unhandled_ui_error' });
  }

  render(): JSX.Element | React.ReactNode {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary-loading-spinner">
          <LoadingSpinner overlayStyleOverrides={{ backgroundColor: '#fff' }} />
        </div>
      );
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
